import { render, staticRenderFns } from "./MyAnswer.vue?vue&type=template&id=c8ff9fcc&scoped=true&"
import script from "./MyAnswer.vue?vue&type=script&lang=js&"
export * from "./MyAnswer.vue?vue&type=script&lang=js&"
import style0 from "./MyAnswer.vue?vue&type=style&index=0&id=c8ff9fcc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ff9fcc",
  null
  
)

export default component.exports